import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import labelService from './labelService';

// Slice for User Login
export const getStockLabel = createAsyncThunk('/getStockLabel', async (thunkAPI) => {
	try {
		const response = await labelService.getStockLabel();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();

		return thunkAPI.rejectWithValue(message);
	}
});

const initialState = {
	stockLabels: [],
	isError: false,
	isLoading: false,
	isSuccess: false,
	message: '',
};

const authSlice = createSlice({
	name: 'labels',
	initialState,
	reducers: {
		reset: (state) => {
			state.stockLabels = [];
			state.isLoading = false;
			state.isError = false;
			state.isSuccess = false;
			state.message = '';
		},
		resetMessage: (state) => {
			state.message = '';
		},
	},

	extraReducers: (builder) => {
		builder
			.addCase(getStockLabel.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getStockLabel.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.stockLabels = action.payload;
				state.isError = false;
			})
			.addCase(getStockLabel.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			});
	},
});

export const { reset, resetMessage } = authSlice.actions;
export default authSlice.reducer;
